/* eslint-disable import/prefer-default-export */
// this disables import/prefer-default-export to keep the interface on this file
// the same while refactoting

/**
 * Check if any item in the array has children
 *
 * @param {Object[]} items items to check
 * @returns {boolean} true if the `links` has children
 */
const hasChildren = items =>
  items.some(item => item.childItems && item.childItems.length > 0);

/**
 * Check if the given set of links is 4 levels deep
 *
 * @param {Object[]} items items to check
 * @returns {boolean} true if there is at least one link with 4 levels
 */
const isFourLevelsDeep = items => {
  if (!hasChildren(items)) {
    return false;
  }

  for (let i = 0; i < items.length; i += 1) {
    const item = items[i];
    if (item.childItems && item.childItems.length > 0) {
      return true;
    }
  }

  return false;
};

export { isFourLevelsDeep };
